import React, { Fragment, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import Loader from '../common/loaderapp';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Button from 'react-bootstrap-button-loader';
import axios from 'axios';
import FormularioProducto from './formularioProducto';
import {
    createEmptyImageSlots,
    applySlotPayload,
    buildElemtsPayloadFromSlots,
    IMAGE_SLOT_LIMIT
} from './imageSlots';

const ActualizarProducto = (props) => {
    const [imagenes, setImagenes] = useState(createEmptyImageSlots());
    const [ID] = useState(props.pag_actualizar);
    const [look, setLook] = useState(false);
    const [load, setLoad] = useState(false);
    const [modal2, setModal2] = useState(false);
    const [datos, setDatos] = useState({});
    const [code_producto, setCode_producto] = useState('');
    const [url] = useState(     /*  'http://localhost:3000'     */        'https://cms.lprefacciones.mx'     );

    const setImagenSlot = (order, payload = {}) => {
        setImagenes(prev => applySlotPayload(prev, order, payload));
    }

    const parseSustitutosField = (raw) => {
        if(Array.isArray(raw)){
            return raw.map(item => String(item || '').trim()).filter(Boolean);
        }
        if(typeof raw === 'string' && raw.trim().length){
            try{
                const parsed = JSON.parse(raw);
                if(Array.isArray(parsed)){
                    return parsed.map(item => String(item || '').trim()).filter(Boolean);
                }
            }catch{
                return raw.split(',').map(sku => sku.trim()).filter(Boolean);
            }
        }
        return [];
    }

    const toDataURL = (target) => fetch(target)
        .then(response => response.blob())
        .then(blob => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        }));

    const hydrateImagenes = async (imagenesRemotas = [], imagenesUrls = {}) => {
        if (!Array.isArray(imagenesRemotas) || imagenesRemotas.length === 0) {
            setImagenes(createEmptyImageSlots());
            return;
        }
        const limited = imagenesRemotas.slice(0, IMAGE_SLOT_LIMIT);
        const hydrated = await Promise.all(limited.map(async (nombre, index) => {
            const remoteUrl = (imagenesUrls && imagenesUrls[nombre]) ? imagenesUrls[nombre] : '';
            try {
                const dataUrl = await toDataURL(remoteUrl || `${url}/imagenes_detalle?sku=${encodeURIComponent(nombre)}`);
                return {
                    order: index,
                    base64: dataUrl,
                    preview: dataUrl,
                    remoteUrl,
                    fileName: nombre
                };
            } catch (err) {
                console.log('[IMAGEN_PRODUCTO]', err);
                return {
                    order: index,
                    base64: '',
                    preview: remoteUrl || '',
                    remoteUrl,
                    fileName: nombre
                };
            }
        }));
        const baseSlots = createEmptyImageSlots();
        setImagenes(baseSlots.map(slot => {
            const match = hydrated.find(item => item && item.order === slot.order);
            return match ? { ...slot, ...match } : slot;
        }));
    }

    useEffect(() => {
        const cargarProducto = async () => {
            try {
                const response = await fetch(url + '/p_productos', {
                    method: 'PATCH',
                    body: JSON.stringify({ ID }),
                    headers: { 'Content-Type': 'application/json' },
                    credentials: 'include'
                });
                const res = await response.json();
                const datosProducto = { ...res.datos, sustitutos: parseSustitutosField(res.datos.sustitutos) };
                const diasPedido =
                    res.datos?.dias_pedido ??
                    res.datos?.DIAS_PEDIDO ??
                    res.datos?.dias ??
                    '';
                datosProducto.dias_pedido = diasPedido;
                if ('dias' in datosProducto) delete datosProducto.dias;
                setDatos(datosProducto);
                setCode_producto(res.datos.sku);
                await hydrateImagenes(res.listImg, res.listImgUrls || {});
                setLoad(true);
            } catch (err) {
                console.log('Error: ' + err);
            }
        }
        cargarProducto();
    }, [ID, url]);

    const toggle2 = () => setModal2(!modal2);

    const eliminar = () => {
        setLook(true);
        fetch('/p_productos', { method: 'DELETE', body: JSON.stringify({ID}), headers: {'Content-Type': 'application/json'} })
        .then(res => res.json())
        .then(() => {
            fetch(url+'/productos_search', { method: 'DELETE', body: JSON.stringify({ID}), headers: {'Content-Type': 'application/json'}, credentials: 'include'})
            props.setPag_actualizar(0);
        })
        .catch(err => {console.log('Error: '+err);setLook(false)});
    }

    const guardarCambios = () => {
        setLook(true);
        const elemtsPayload = buildElemtsPayloadFromSlots(imagenes);
        axios.request({
            method: 'PUT',
            url: url + '/p_productos',
            withCredentials: true,
            data: { ID, elemts: elemtsPayload, datos }
        })
        .then(() => {
            return fetch(url+'/productos_search', {
                method: 'PUT',
                body: JSON.stringify({
                    ID,
                    datos:{
                        sku: datos.sku,
                        name: datos.name,
                        marca: datos.marca,
                        description: datos.description,
                        short_description: datos.short_description,
                        oferta: datos.oferta==null ? '' : datos.oferta
                    },
                    visible: datos.visible
                }),
                headers: {'Content-Type': 'application/json'},
                credentials: 'include'
            });
        })
        .then(() => {
            props.setPag_actualizar(0);
        })
        .catch(error => {
            console.log(error);
            const message = error?.response?.data?.resultado || error?.response?.data?.detalle || error?.message || 'No se pudo actualizar el producto.';
            toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
            setLook(false);
        });
    }

    const submitFormulario=()=>{
        const code_p = datos.sku || '';
        if(code_p.length === 0){
            toast.warn('El campo SKU no puede estar vacío.',{ position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }
        const unidadSeleccionada = String(datos.MAX_UNIDAD || datos.MIN_UNIDAD || datos.unidad || '').trim();
        if (!unidadSeleccionada) {
            toast.warn('El campo Unidad es obligatorio.', { position: toast.POSITION.BOTTOM_RIGHT });
            return;
        }
        if (code_producto === code_p) {
            guardarCambios();
            return;
        }
        fetch('/p_producto_unico', { method: 'POST', body: JSON.stringify({ CODIGO_REFERENCIA: code_p }), headers: { 'Content-Type': 'application/json' } })
            .then(res => res.json())
            .then(res => {
                if (res.RESULT === 0) {
                    guardarCambios();
                }
                else {
                    toast.warn('El SKU debe ser único.', { position: toast.POSITION.BOTTOM_RIGHT });
                }
            })
            .catch(err => { console.log('Error: ' + err) })
    }

    return (
        <Fragment>
            <div className="col-sm-12">
                <div className="card">
                    <div className="card-header">
                        <button className="btn btn-outline-light-2x txt-dark mb-4" onClick={()=> props.setPag_actualizar(0)}>
                            <i className="icofont icofont-arrow-left"/>Regresar
                        </button>
                        {   
                            load ?
                            <Fragment>
                                <div className="col-12">
                                    <FormularioProducto
                                        datos={datos}
                                        setDatos={setDatos}
                                        actualizar
                                        imagenes={imagenes}
                                        onImagenChange={setImagenSlot}
                                    />
                                </div>
                                <div className="col-md-12 mt-2 d-flex justify-content-between">
                                    <div className="text-left">
                                        <button className='btn btn-danger btn-lg ml-4' type="button" onClick={toggle2}>Borrar <i className="icon-trash" aria-hidden="true"></i></button>
                                    </div>
                                    <div className="text-right">
                                        <Button className='btn-lg mr-4' onClick={submitFormulario} loading={look}>{!look?'Guardar':'Espera'}</Button>
                                    </div>
                                </div>
                                <Modal isOpen={modal2} toggle={toggle2} className="modal-body" centered={true}>
                                    <ModalHeader toggle={toggle2}>Eliminar producto</ModalHeader>
                                    <ModalBody>
                                        ¿Está seguro que desea eliminar este producto?
                                    </ModalBody>
                                    <ModalFooter>
                                        <Button className="btn-danger" onClick={eliminar} disabled={look}><i className="icofont icofont-trash" />Eliminar</Button>
                                        <Button color="secondary" onClick={toggle2}>Cancelar</Button>
                                    </ModalFooter>
                                </Modal>
                            </Fragment>
                            :
                            <Loader/>
                        }
                        
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
 
export default ActualizarProducto;
